import { Box, Typography } from '@mui/material';
import { COLORS } from '../utils/constants';
import SecurityIcon from '@mui/icons-material/Security';
import CheckIcon from '@mui/icons-material/Check';
import { Grid, Paper, Stack } from '@mui/material';
import React from 'react';

/**
 * Safety guidelines display component
 */
export default function SafetyGuidelines({ isDesktop }) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        borderRadius: 3,
        bgcolor: `${COLORS.accent}05`,
        border: `1px solid ${COLORS.accent}30`,
        position: 'static',
        overflow: 'hidden',
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <SecurityIcon sx={{ fontSize: 20, color: COLORS.accent }} />
          <Typography variant="subtitle2" sx={{ fontWeight: 700, color: COLORS.textPrimary }}>
            Safety Guidelines
          </Typography>
        </Box>
        <Stack spacing={1.2}>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <CheckIcon
              sx={{
                fontSize: 14,
                color: COLORS.accent,
                mt: 0.3,
                flexShrink: 0,
              }}
            />
            <Typography
              variant="caption"
              sx={{
                color: COLORS.textSecondary,
                lineHeight: 1.4,
                fontSize: '0.7rem',
              }}
            >
              Pack items securely with bubble wrap or padding
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <CheckIcon
              sx={{
                fontSize: 14,
                color: COLORS.accent,
                mt: 0.3,
                flexShrink: 0,
              }}
            />
            <Typography
              variant="caption"
              sx={{
                color: COLORS.textSecondary,
                lineHeight: 1.4,
                fontSize: '0.7rem',
              }}
            >
              Label fragile items clearly on package
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <CheckIcon
              sx={{
                fontSize: 14,
                color: COLORS.accent,
                mt: 0.3,
                flexShrink: 0,
              }}
            />
            <Typography
              variant="caption"
              sx={{
                color: COLORS.textSecondary,
                lineHeight: 1.4,
                fontSize: '0.7rem',
              }}
            >
              Seal boxes with strong packing tape
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <CheckIcon
              sx={{
                fontSize: 14,
                color: COLORS.accent,
                mt: 0.3,
                flexShrink: 0,
              }}
            />
            <Typography
              variant="caption"
              sx={{
                color: COLORS.textSecondary,
                lineHeight: 1.4,
                fontSize: '0.7rem',
              }}
            >
              Avoid prohibited items (hazardous materials)
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <CheckIcon
              sx={{
                fontSize: 14,
                color: COLORS.accent,
                mt: 0.3,
                flexShrink: 0,
              }}
            />
            <Typography
              variant="caption"
              sx={{
                color: COLORS.textSecondary,
                lineHeight: 1.4,
                fontSize: '0.7rem',
              }}
            >
              Include sender & receiver contact details
            </Typography>
          </Box>
        </Stack>
      </Box>
    </Paper>
  );
}
